import { VehicleModulesResearchResponse } from '../models/response/VehicleModulesResearchResponse'
import { api } from './api'

export class VehicleModulesService {

	static async getTree(vehicleId: number): Promise<VehicleModulesResearchResponse> {
		const response = await api.get(`/vehicle/modules/research?vehicleId=${vehicleId}`)
		return response.data as VehicleModulesResearchResponse
	}

	static async buyOrResearch(vehicleId: number, moduleId: number): Promise<void> {
		await api.post('/vehicle/modules/buy', { vehicleId, moduleId })
	}

	static async eqip(vehicleId: number, moduleId: number): Promise<void> {
		await api.post('/vehicle/modules/equip', { vehicleId, moduleId })
	}
}